import moment from 'moment-timezone';

export default (utc, user) => (
  moment.utc(utc).tz(user.timezone || moment.tz.guess()).format('DD MMM hh:mm:ss a')
);
